<template>
  <div id="app" class="app">
    <div class="app__preloader is-active" ref="preloader" v-if="hasPreloader">
      <div class="app__preloader__wrapper">
        <div class="app__preloader__inner">
          <div class="app__preloader__title__wrapper">
            <div class="app__preloader__title__container">
                <div class="app__preloader__title__inner">
                    <h2 class="app__preloader__title__elem"> labor of fashion </h2>
                    <h2 class="app__preloader__title__elem"> labor of fashion </h2>
                </div>
            </div>
            <div class="app__preloader__title__container">
                <div class="app__preloader__title__inner">
                    <h2 class="app__preloader__title__elem"> labor of fashion </h2>
                    <h2 class="app__preloader__title__elem"> labor of fashion </h2>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-transition ref="transition"/>
    <app-grain-bg v-if="isGrey"/>
    <app-header/>
    <router-view :key="$route.fullPath" ref="view"/>
    <app-footer/>
    <search />
  </div>
</template>

<script>
  import EventHub from '@/utils/EventHub.js'
  import Support from '@/utils/Support.js'

  import AppHeader from '@/components/AppHeader.vue'
  import AppFooter from '@/components/AppFooter.vue'
  import AppTransition from '@/components/AppTransition.vue'
  import AppGrainBg from '@/components/AppGrainBg.vue'

  import Search from '@/views/Search.vue'

  export default {
    name: 'App',

    components: {
      AppHeader,
      AppFooter,
      AppTransition,
      AppGrainBg,
      Search
    },

    data() {
      return {
        isGrey: false,
        hasPreloader: true
      }
    },

    watch:
    {
        $route: 'onRouteChange'
    },

    created() {
      // console.log('app created')
      console.log(`
                    /
               ,.. /
             ,'   ';
  ,,.__    _,' /';  .
 :','  ~~~~    '. '~
:' (   )         )::,       By https://antonin.space
'. '. .=----=..-~  .;'
 '  ;'  ::   ':.  '"
   (:   ':    ;)
    \\   '"  ./
     '"      '"`)

      this.support = Support

      this.windowObj = {
        width: window.innerWidth,
        height: window.innerHeight
      }

      this.isGrey = this.$route.meta.grey
      this.onSetBackground(this.isGrey)

      this.addListeners()

      // Preloader
      EventHub.$on('app:preloading-end', this.onPreloadingEnd)
      this.$root.firstPage = true
    },

    mounted() {
      // console.log('app mounted')
      EventHub.$emit('application:on-route-change', this.$route, this.$route)

      this.$refs.view.notLoaded = true

      this.onResize()
      this.onTick()
    },

    destroyed() {

    },

    methods: {
      addListeners() {
        window.addEventListener('resize', this.onResize)
        window.addEventListener('scroll', this.onScroll)
      },

      onPreloadingEnd()
      {
        window.setTimeout(() => {
          this.hasPreloader = false
        }, 1200)
        
        this.$refs.preloader.classList.remove('is-active')

        this.$refs.view.notLoaded = false

        EventHub.$off('app:preloading-end', this.onPreloadingEnd)
      },

      onRouteChange(to, from) {
        // console.log('on route change', to, from)

        if(this.$root.firstPage)
        {
          this.$root.firstPage = false
        }
        
        if(!to.meta.grey === this.isGrey)
        {
          this.onSetBackground(to.meta.grey)
        }
        this.isGrey = to.meta.grey

        if(window.ga)
        {
            // console.log('update ga')
            const ga = window.ga

            const pageTitre = to.name
            const pagePath = to.path

            // Google Analytics tracking
            ga('set', { page: pagePath, title: pageTitre })
            ga('send', 'pageview')
        }

        EventHub.$emit('application:on-route-change', to, from)
      },

      onSetBackground(isGrey) {
        if(isGrey)
        {
          document.body.classList.add('is-grey')
        }
        else
        {
          document.body.classList.remove('is-grey')
        }
      },

      onResize()
      {
          this.windowObj.width  = window.innerWidth
          this.windowObj.height = window.innerHeight

          EventHub.$emit('window:resize', this.windowObj)
      },

      onScroll()
      {
          EventHub.$emit('application:on-scroll', window.scrollY)
      },

      onTick()
      {
          EventHub.$emit('application:on-tick')
          requestAnimationFrame(this.onTick)
      },
    }
  }
</script>

<style lang="stylus">
@import './styles/index.styl'

.app__preloader
  cursor wait
  z-index 99
  position fixed
  height 100vh
  width 100vw
  overflow hidden
  background-color #0d0d16
  transform translate3d(0, -100%, 0)
  transform-origin top left
  transition transform 1.2s $ease-in-out-circ
  interpolate('padding-top', 1600px, 2560px, 300px, 460px);

  @media(max-width 1600px)
    interpolate('padding-top', 768px, 1600px, 180px, 300px);

  @media(max-width 768px)
    padding-top 0


  &.is-active
        transform translate3d(0, 0, 0)

.app__preloader__wrapper
    position relative
    width 100vw
    height 100vh
    transform translate3d(0, 100%, 0)
    transform-origin top left
    transition transform 1.2s $ease-in-out-circ

    .is-active &
        transform translate3d(0, 0, 0) scale(1)

.app__preloader__inner
    position relative
    width 100vw
    height 100vh

    transform scale(0.9)
    transform-origin top center
    transition transform 1s linear 0.25s

    .is-active &
        transform scale(1)

.app__preloader__title__wrapper
    position absolute
    animation-name textSlideIntro
    animation-duration 20s
    animation-timing-function linear
    animation-delay 0s
    animation-iteration-count infinite
    will-change transform

    @media(max-width 768px)
      top 50%
      animation-name textSlideIntroMobile

.app__preloader__title__container
    display inline-block

    &:last-child
        position absolute
        top 0
        left 100%

.app__preloader__title__inner
    display flex
    flex-direction row
    flex-wrap nowrap

.app__preloader__title__elem
    width 100%
    margin-right 100px
    font-family 'Sabon'
    text-transform uppercase
    text-align center
    line-height 1
    letter-spacing 0.2em
    color $white
    white-space nowrap
    interpolate('font-size', 1600px, 2560px, 120px, 172px);

    @media(max-width 1600px)
        interpolate('font-size', 768px, 1600px, 58px, 120px);

@keyframes textSlideIntro {
  from {
    transform translate3d(0, 53%, 0)
  }

  to {
      transform translate3d(-100%, 53%, 0)
  }
}
@keyframes textSlideIntroMobile {
  from {
    transform translate3d(0, -75%, 0)
  }

  to {
      transform translate3d(-100%, -75%, 0)
  }
}
</style>
